<template>
  <div>
    <el-dialog
      class="form-modal"
      :visible.sync="visible"
      :fullscreen="true"
      :show-close="false"
      :modal="false"
      v-loading="loading"
      @open="populateFields"
    >
      <div class="modal-header">
        <div class="modal-header-layout flex grid-6 align-center">
          <h1 class="modal-title col-2">{{ context }} User</h1>
          <div class="modal-actions col-2">
            <el-button type="primary" @click="handleSubmit">{{
              context === "Edit" ? "Save" : context
            }}</el-button>
            <el-button type="default" @click="handleClose">Cancel</el-button>
          </div>
        </div>
      </div>
      <el-form>
        <recent-audits
          service="User"
          :record="selectedUser"
          v-if="context === 'Edit'"
        />
        <div class="button-group mt-0 mb-0" v-if="context === 'Edit'">
          <el-checkbox-group v-model="resetPassword">
            <el-checkbox :label="true" class="black-text">
              Reset password and send invite?
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="inline-form-group">
          <el-checkbox
            :value="form.enableOperatorPanel"
            @change="form.enableOperatorPanel = !form.enableOperatorPanel"
          >
            Enable Operator Panel Access
          </el-checkbox>
        </div>

        <el-input type="text" v-model="form.email" placeholder="Enter Email">
          <template class="label-prefix" slot="prefix">Email</template>
        </el-input>
        <DadsSelect
          v-model="form.timezone"
          filterable
          placeholder="Select time zone"
        >
          <template slot="prefix">Time zone</template>
          <el-option
            v-for="(item, index) in timezoneOptions"
            :key="index"
            :value="item.name"
            :label="item.name"
          />
        </DadsSelect>
        <DadsSelect
          v-model="form.userRole"
          filterable
          placeholder="Select role"
        >
          <template slot="prefix">User Role</template>
          <el-option
            v-if="+this.user.userRole === 1"
            :key="1"
            label="Platform Administrator"
            :value="1"
          />
          <el-option
            v-if="+this.user.userRole === 1 || +this.user.userRole === 11"
            :key="11"
            label="Partner Administrator"
            :value="11"
          />
          <el-option
            v-for="role in roleOptions"
            :key="role.value"
            :label="role.label"
            :value="role.value"
          />
        </DadsSelect>
        <div
          class="inline-form-group"
          v-if="
            form.userRole === 7 || +form.userRole === 3 || +form.userRole === 12
          "
          style="margin-top: 5px"
        >
          <el-switch v-model="form.enableReporting"> </el-switch>
          <h4 class="ml-10 black-text mt-0 mb-0">
            Enable admin reporting features?
          </h4>
        </div>
        <div v-if="+form.userRole === 11 && +user.userRole === 1">
          <el-select
            filterable
            v-model="form.partnerId"
            placeholder="Select partner account"
          >
            <template slot="prefix">Partner account</template>
            <el-option
              v-for="item in partnerOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </div>
        <div v-if="+form.userRole === 3 || +form.userRole === 12">
          <h2 class="form-section-header">Assign accounts</h2>
          <el-select
            v-model="form.tenantIds"
            :remote-method="(query) => (tenantsQuery = query)"
            remote
            multiple
            filterable
            clearable
          >
            <template slot="prefix"
              ><span style="opacity: 0">Accounts</span></template
            >
            <el-option
              v-for="tenant in tenantOptions"
              :key="tenant.id"
              :label="tenant.name"
              :value="tenant.id"
            />
          </el-select>
        </div>

        <DadsSelect
          v-model="form.tenantId"
          v-show="+form.userRole"
          :placeholder="
            +form.userRole < 5 || +form.userRole === 12
              ? 'Select home account'
              : 'Select account'
          "
          :remote-method="(query) => (accountsQuery = query)"
          remote
          filterable
        >
          <template slot="prefix">{{
            +form.userRole < 5 || +form.userRole === 12
              ? "Home account"
              : "Account"
          }}</template>
          <el-option
            v-for="(tenant, index) in accountOptions"
            :key="index"
            :label="tenant.name"
            :value="tenant.id"
          >
          </el-option>
        </DadsSelect>
        <dads-select
          v-loading="extensionOptionsLoading"
          v-model="form.extension"
          v-show="form.tenantId"
          filterable
          clearable
          remote
          :remote-method="searchExtensions"
          placeholder="Assign extension"
        >
          <template slot="prefix"> Extension </template>
          <el-option
            v-for="exten in availableExtensions"
            :key="exten.id"
            :label="exten.name + ' - ' + exten.number"
            :value="exten.number"
          >
          </el-option>
        </dads-select>

        <div v-if="+form.userRole === 13 || +form.userRole === 14">
          <h2 class="form-section-header">
            <span> Assign to Pharmacy Locations </span>
          </h2>
          <el-select
            v-model="form.pharmacyLocations"
            remote
            :remote-method="searchPharmacyLocations"
            filterable
            multiple
            placeholder="Select Locations"
            class="mt-5"
            value-key="id"
          >
            <template slot="prefix"
              ><span style="opacity: 0">Pharmacies</span></template
            >
            <el-option
              v-for="pharmacy in pharmacyOptions"
              :key="pharmacy.id"
              :label="pharmacy.name"
              :value="pharmacy"
            />
          </el-select>
        </div>

        <div v-show="form.tenantId" v-if="availableQueues.length">
          <div class="inline-form-group" style="margin-top: 15px">
            <el-switch v-model="form.receiveQueueReports"> </el-switch>
            <h4 class="ml-10 black-text mt-0 mb-0">
              Enable receiving queue manager reports?
            </h4>
          </div>
          <div class="inline-form-group" style="margin-top: 10px">
            <el-switch v-model="form.receiveQueueUserReports"> </el-switch>
            <h4 class="ml-10 black-text mb-0 mt-0">
              Enable receiving queue agent reports?
            </h4>
          </div>
          <h2 class="form-section-header">
            <span> Assign as manager to queues: </span>
          </h2>

          <el-select
            v-model="form.adminQueues"
            filterable
            multiple
            placeholder="Select queues"
            class="mt-5"
          >
            <template slot="prefix"
              ><span style="opacity: 0">Queues</span></template
            >
            <el-option
              v-for="queue in availableQueues"
              :key="queue.id"
              :label="queue.name"
              :value="queue.id"
            />
          </el-select>

          <h2 class="form-section-header">Assign as agent to queues:</h2>
          <el-select
            v-model="form.agentQueues"
            placeholder="Select queues"
            filterable
            multiple
          >
            <template slot="prefix"
              ><span style="opacity: 0">Queues</span></template
            >
            <el-option
              v-for="queue in availableQueues"
              :key="queue.id"
              :label="queue.name"
              :value="queue.id"
            />
          </el-select>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
import feathersClient, { apiV2Host } from "@/feathers/feathers-client";
import debounce from "lodash/debounce";
import DadsSelect from "@/components/select";
import RecentAudits from "@/components/RecentAudits";

export default {
  name: "UserForm",
  props: {
    context: { required: true },
    recordId: { default: "" },
    visible: { default: false },
    timezoneOptions: { required: true, default: null },
    partnerOptions: { required: true }
  },
  components: {
    DadsSelect,
    RecentAudits
  },
  data() {
    return {
      loading: false,
      extensionOptionsLoading: false,
      pharmacyOptionsLoading: false,
      availableExtensions: [],
      resetPassword: false,
      availableQueues: [],
      selectedUser: null,
      roleOptions: [
        { value: 3, label: "Account Administrator" },
        { value: 9, label: "Reports Administrator" },
        { value: 7, label: "Queue Manager" },
        { value: 5, label: "User" },
        { value: 12, label: "Pharmacy Owner" },
        { value: 13, label: "Pharmacy Admin" },
        { value: 14, label: "Pharmacy User" }
      ],
      pharmacies: [],
      form: {
        email: "",
        userRole: "",
        tenantId: null,
        extension: "",
        tenantIds: [],
        adminQueues: [],
        enableReporting: false,
        receiveQueueReports: false,
        receiveQueueUserReports: false,
        timezone: "",
        partnerId: null,
        agentQueues: [],
        enableOperatorPanel: true,
        pharmacyLocations: []
      },

      tenantOptions: [],
      pharmacyOptions: [],
      tenantsQuery: "",
      accountOptions: [],
      accountsQuery: ""
    };
  },
  computed: {
    userEmail() {
      return this.form.email;
    },
    user() {
      return this.$store.state.auth.user;
    },
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    formTenant() {
      return this.form.tenantId;
    },
    formUserRole() {
      return this.form.userRole;
    }
  },
  watch: {
    userRecord() {
      if (this.context === "Edit" && this.visible) {
        this.queryQueues();
        if (
          +this.selectedUser.userRole === 13 ||
          +this.selectedUser.userRole === 14
        ) {
          this.queryPharmacyLocations();
          this.queryUserPharmacies();
        }
      }
    },
    userEmail: debounce(function () {
      this.getAssignedExtension();
    }, 500),

    userExtension() {
      if (this.visible) {
        this.form.extension = this.userExtension
          ? this.userExtension.number
          : "";
      }
    },

    formTenant() {
      if (this.formTenant) {
        this.availableExtensions = [];
        this.form.extension = "";
        this.getAssignedExtension();
        this.queryQueues();
      }
    },

    formUserRole(role) {
      if (
        (role === 3 && this.context === "Create") ||
        (role === 12 && this.context === "Create")
      ) {
        this.form.enableReporting = true;
      }

      if (role === 13 || role === 14) {
        this.queryPharmacyLocations();
        this.queryUserPharmacies();
      }
    },

    tenantsQuery: debounce(function () {
      this.queryTenantOptions();
    }, 500),

    accountsQuery: debounce(function () {
      this.queryAccountOptions();
    }, 500),

    visible() {
      if (this.context === "Edit") {
        this.queryQueues();
      }
    }
  },

  methods: {
    ...mapActions("users", {
      updateUser: "patch",
      createUser: "create",
      removeUser: "remove"
    }),
    queryQueues() {
      feathersClient
        .service("queues")
        .find({
          query: {
            tenantId: this.form.tenantId
          }
        })
        .then((res) => {
          this.availableQueues = [...res];
        });
    },
    selectUserPharmacies(pharmacy) {
      const pharmacyOption = this.pharmacyOptions.find(
        (option) => +option.id === +pharmacy[0].id
      );

      this.form.pharmacyLocations.push(pharmacyOption);
    },
    queryUserPharmacies() {
      feathersClient
        .service("users-pharmacy-locations")
        .find({
          query: {
            userId: this.selectedUser.id
          }
        })
        .then((res) => {
          // Create pharmacy objects from the service response
          const selectedPharmacies = res.map((pharmacy) => ({
            id: pharmacy.locationId,
            name: pharmacy.locationName,
            type: pharmacy.locationType
          }));

          // Ensure all selected pharmacies are in the options array
          selectedPharmacies.forEach((selectedPharmacy) => {
            const existingIndex = this.pharmacyOptions.findIndex(
              (p) => p.id === selectedPharmacy.id
            );
            if (existingIndex === -1) {
              this.pharmacyOptions.push(selectedPharmacy);
            } else {
              this.pharmacyOptions[existingIndex] = selectedPharmacy;
            }
          });

          // Set form value to the pharmacy objects
          this.form.pharmacyLocations = selectedPharmacies;
        });
    },
    async queryPharmacyLocations() {
      const res = await fetch(`${apiV2Host}/admin/pharmacy/`, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + this.$store.state.auth.accessToken
        }
      });
      const values = await res.json();
      this.pharmacyOptions = values.records;
    },
    handleSubmit() {
      if (this.context === "Edit") {
        this.handleEdit();
      }
      if (this.context === "Create") {
        this.handleCreate();
      }
    },
    handleCreate() {
      let data = { ...this.form };
      data.receiveQueueReports = data.receiveQueueReports ? 1 : 0;
      data.receiveQueueUserReports = data.receiveQueueUserReports ? 1 : 0;
      data.enableReporting = data.enableReporting ? 1 : 0;
      data.enableOperatorPanel = data.enableOperatorPanel ? 1 : 0;

      const { userRole } = this.form;

      if ([13, 14].includes(+userRole) && data.pharmacyLocations) {
        const createData = [];
        for (let i = 0; i < data.pharmacyLocations.length; i++) {
          createData.push({
            locationId: data.pharmacyLocations[i].id,
            locationType: data.pharmacyLocations[i].locationType,
            locationName: data.pharmacyLocations[i].name
          });
        }
        data.pharmacyLocations = createData;
      }

      if (+userRole === 11 && +this.user.userRole === 11) {
        data.partnerId = this.user.partnerId;
      }

      if (!this.form.tenantId) {
        this.$notify({
          title: "Invalid Data",
          message: "You must assign a home account!",
          type: "error"
        });
        return;
      }
      if (![1, 12, 13, 14].includes(+userRole) && !this.form.extension.length) {
        this.$notify({
          title: "Invalid Data",
          message: "You must assign an extension!",
          type: "error"
        });
        return;
      }

      this.$confirm(
        "Confirm User Creation? Please tell the new user to check their email for the invite that will contain their login information.",
        "Warning",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning"
        }
      )
        .then(() => {
          this.loading = true;
          this.createUser(data)
            .then((res) => {
              this.$notify({
                title: "Success",
                message: "User " + res.email + " has been created!",
                type: "success"
              });
              this.loading = false;
            })
            .then(() => {
              this.clearFormFields();
              this.$emit("modalClosed");
            })
            .catch((error) => {
              this.loading = false;
              console.log(error);
              if (error.hasOwnProperty("errors")) {
                if (error.name === "BadRequest") {
                  const errorMessage = error.errors.tenantIds || error.message;
                  const message = error.errors.length
                    ? error.errors[0].message
                    : error.message;
                  this.$notify({
                    title: error.name,
                    message:
                      message.indexOf("us_username") >= 0
                        ? "Account with this email already exists!"
                        : errorMessage,
                    type: "error"
                  });
                } else {
                  const errorMessage =
                    error.errors.tenantIds || error.errors[0].message;
                  this.$notify({
                    title: error.message,
                    message:
                      error.errors[0].message.indexOf("us_username") >= 0
                        ? "Account with this email already exists!"
                        : errorMessage,
                    type: "error"
                  });
                }
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }
            });
        })
        .catch(() => true);
    },

    handleEdit() {
      let data = { ...this.form, resetPassword: this.resetPassword };
      data.receiveQueueReports = data.receiveQueueReports ? 1 : 0;
      data.receiveQueueUserReports = data.receiveQueueUserReports ? 1 : 0;
      data.enableReporting = data.enableReporting ? 1 : 0;
      data.enableOperatorPanel = data.enableOperatorPanel ? 1 : 0;

      const { userRole } = this.form;

      //provide partner id if user making change is promoting to partner admin
      if (+this.user.userRole === 11 && userRole === 11) {
        data.partnerId = this.user.partnerId;
      }

      if (!this.form.tenantId) {
        this.$notify({
          title: "Invalid Data",
          message: "You must assign a home account!",
          type: "error"
        });
        return;
      }
      const neededRoles = [1, 12, 13, 14];
      if (!neededRoles.includes(+userRole) && !this.form.extension.length) {
        this.$notify({
          title: "Invalid Data",
          message: "You must assign an extension!",
          type: "error"
        });
        return;
      }

      if ([13, 14].includes(+userRole) && data.pharmacyLocations) {
        const createData = [];
        for (let i = 0; i < data.pharmacyLocations.length; i++) {
          createData.push({
            locationId: data.pharmacyLocations[i].id,
            locationType: data.pharmacyLocations[i].locationType,
            locationName: data.pharmacyLocations[i].name
          });
        }
        data.pharmacyLocations = createData;
      }

      this.$confirm("Update User Details?", "Warning", {
        confirmButtonText: "Update",
        cancelButtonText: "Cancel"
      })
        .then(() => {
          this.loading = true;
          this.updateUser([this.recordId, data])
            .then((res) => {
              this.loading = false;
              this.$notify({
                title: "Success",
                message: "User " + res.email + " has been updated!",
                type: "success"
              });
              this.clearFormFields();
              this.$emit("modalClosed");
            })
            .catch((error) => {
              this.loading = false;
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }
            });
        })
        .catch(() => true);
    },
    handleClose() {
      this.$emit("modalClosed");
      this.clearFormFields();
    },
    deleteRecord(id) {
      this.$confirm("Permanently delete this user?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        type: "warning"
      })
        .then(() => {
          feathersClient.service("users-pharmacy-locations").remove({
            query: {
              userId: id
            }
          });
          this.removeUser(id)
            .then((res) => {
              this.$notify({
                title: "Success",
                message: "User " + res.email + " has been removed!",
                type: "success"
              });
              this.$emit("modalClosed");
              this.clearFormFields();
            })
            .catch((error) => {
              this.$notify({
                title: error.name,
                message: error.message,
                type: "error"
              });
            });
        })
        .catch(() => true);
    },
    clearFormFields() {
      this.resetPassword = false;
      this.form.tenantId = null;
      this.form.tenantIds = [];
      this.form.adminQueues = [];
      this.form.agentQueues = [];
      this.availableExtensions = [];
      this.form.receiveQueueReports = false;
      this.form.email = "";
      this.form.userRole = "";
      this.form.extension = "";
      this.form.partnerId = null;
      this.form.pharmacyLocations = [];
      this.pharmacyOptions = [];

      this.accountOptions = [];
      this.accountsQuery = "";
      this.tenantOptions = [];
      this.tenantsQuery = "";
    },

    async populateFields() {
      if (this.recordId) {
        this.loading = true;
        const record = await feathersClient.service("users").get(this.recordId);
        this.selectedUser = record;

        for (let key in record) {
          if (record.hasOwnProperty(key)) {
            if (this.form.hasOwnProperty(key)) {
              this.form[key] = record[key];
            }
          }
        }
        this.form.receiveQueueReports = !!record.receiveQueueReports;
        this.form.receiveQueueUserReports = !!record.receiveQueueUserReports;
        this.form.enableReporting = !!record.enableReporting;
        this.form.enableOperatorPanel = !!record.enableOperatorPanel;
        if (record.myExtension) {
          this.form.agentQueues = record.myExtension.queueIds.filter(
            (item) => !!item
          );
        }
        this.loading = false;
      }

      if (this.context === "Create") {
        this.form.timezone = this.selectedTenant.timezone.name;
      }

      // important to call here to properly populate the options
      await this.queryAccountOptions();
      await this.queryTenantOptions();
    },

    getAssignedExtension() {
      if (this.form.tenantId) {
        this.extensionOptionsLoading = true;
        feathersClient
          .service("extensions")
          .find({
            query: {
              tenantId: this.form.tenantId,
              email: this.form.email
            }
          })
          .then((res) => {
            this.availableExtensions = [];
            if (res.length) {
              this.availableExtensions.push(res[0]);
              this.form.extension = res[0].number;
            } else {
              this.form.extension = "";
            }
            this.extensionOptionsLoading = false;
          });
      }
    },

    searchExtensions(query) {
      if (query.length) {
        feathersClient
          .service("extensions")
          .find({
            query: {
              tenantId: this.form.tenantId,
              $or: [
                { name: { $like: `%${query}%` } },
                { number: { $like: `%${query}%` } }
              ],
              $limit: 50
            }
          })
          .then((res) => {
            this.availableExtensions = res.filter(
              (item) =>
                item.email === null ||
                item.email === "" ||
                item.email === this.form.email
            );
          });
      } else {
        this.availableExtensions = [];
      }
    },

    async searchPharmacyLocations(query) {
      let selectedPharmacies = [];
      if (Array.isArray(this.form.pharmacyLocations)) {
        selectedPharmacies = this.form.pharmacyLocations.filter(
          (pharmacy) =>
            typeof pharmacy === "object" && pharmacy.id && pharmacy.name
        );
      }

      if (query.length) {
        this.pharmacyOptionsLoading = true;
        const res = await fetch(`${apiV2Host}/admin/pharmacy?name=${query}`, {
          method: "GET",
          headers: {
            Authorization: "Bearer " + this.$store.state.auth.accessToken
          }
        });
        const values = await res.json();

        const searchResults = values.records.filter(
          (pharmacy) =>
            !selectedPharmacies.find((selected) => selected.id === pharmacy.id)
        );

        this.pharmacyOptions = [...selectedPharmacies, ...searchResults];
        this.pharmacyOptionsLoading = false;
      } else {
        this.pharmacyOptions = [...selectedPharmacies];
      }
    },

    async queryTenants(url) {
      const token = this.$store.state.auth.accessToken;

      try {
        const res = await axios.get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        });

        return res.data.records;
      } catch (err) {
        //
      }
    },

    async queryAccountOptions() {
      const url = `${apiV2Host}/admin/tenants${
        this.accountsQuery ? `?query=${this.accountsQuery}` : ""
      }`;

      const records = await this.queryTenants(url);
      this.accountOptions = [...records];

      if (this.form.tenantId) {
        const searchTenant = records.find(
          (item) => item.id === this.form.tenantId
        );

        if (!searchTenant) {
          feathersClient
            .service("tenants")
            .get(this.form.tenantId)
            .then((res) => {
              this.accountOptions.push(res);
            });
        }
      }
    },

    async queryTenantOptions() {
      const url = `${apiV2Host}/admin/tenants${
        this.tenantsQuery ? `?query=${this.tenantsQuery}` : ""
      }`;

      const records = await this.queryTenants(url);
      this.tenantOptions = [...records];

      const tenantOptionIds = this.tenantOptions.map((item) => item.id);
      const notInOptionIds = this.form.tenantIds.filter(
        (id) => !tenantOptionIds.includes(id)
      );

      if (notInOptionIds && notInOptionIds.length) {
        feathersClient
          .service("tenants")
          .find({
            query: {
              id: { $in: notInOptionIds }
            }
          })
          .then((res) => {
            this.tenantOptions.push(...res);
          });
      }
    }
  },

  created() {
    if (this.user) {
      this.queryAccountOptions();
      this.queryTenantOptions();
    }
  }
};
</script>

<style lang="scss" scoped>
.button-group {
  max-width: 600px;
  margin: auto;
}

.el-checkbox {
  margin-left: 0;
}
</style>
